import React from 'react'
import { TooltipProps } from 'recharts'

import { Nullable } from '@src/Application/Types/Opt'

import { Label, Row, TooltipWrapper } from './CustomTooltip.styled'

export const CustomTooltip = (props: TooltipProps<number, string>): Nullable<JSX.Element> => {
    const { active, payload, label } = props

    if (active && payload && payload.length) {
        return (
            <TooltipWrapper>
                <Label>{label}</Label>
                {payload.map((p, i) => (
                    <Row key={`t${i}-p.name`}>
                        {p.name}: {p.value}
                    </Row>
                ))}
            </TooltipWrapper>
        )
    }

    return null
}
